export const InFoPartNers = [
  {
    logo: 'https://eoc.vn/themes/giaodienweb/images/logo.png',
    href: '',
  },
  {
    logo: 'https://dunganthanh.com/thumb/170x100/2/upload/hinhanh/logow-5371.png',
    href: '',
  },
  {
    logo: 'https://centralretail.com.vn/wp-content/uploads/2022/08/GO.png',
    href: '',
  },
  {
    logo: 'https://ckporcelain.vn/wp-content/uploads/2025/10/coop-mart.png',
    href: '',
  },
  {
    logo: 'https://cdn.haitrieu.com/wp-content/uploads/2023/11/Logo-Mega-Market.png',
    href: '',
  },
  {
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/WinMart_logo.png',
    href: '',
  },
  {
    logo: 'https://www.vietguys.biz/images/partners/retail/emart.png',
    href: '',
  },
  // {
  //   logo: 'https://inofoshoahuuco-vcnhh.com/images/6/e/5/5/d/6e55d0ddd20b11e32382d1bb11113e2976933796-logoict.png?g-ed283bd4',
  //   href: '',
  // },
  // {
  //   logo: 'https://dulichmedia.dalat.vn//Images/LDG/myduyen/Golf%20Valley/cropper_636954265266728075.jpg',
  //   href: '',
  // },
  // {
  //   logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSiQmAyu7uF1XQJvo7BP0UzaDwYoXrpQbCapO2KEeQt-g&s',
  //   href: '',
  // },
  // {
  //   logo: 'https://cdn.haitrieu.com/wp-content/uploads/2021/10/Logo-DH-Cong-Nghe-Thong-Tin-UIT-V.png',
  //   href: '',
  // },
  // {
  //   logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSc6Gw2P1UiFJawNDpZh1oTLBTF5b5oPud3Ul5C9R0Xow&s',
  //   href: '',
  // },
  // {
  //   logo: 'https://dhcdongnai.com.vn/wp-content/uploads/2022/04/LOGO-DHC-1.png',
  //   href: '',
  // },
];
